import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import ZoneChart from "./ZoneChart";

type Zone = {
    x: string,
    y: number,
    id: string
}
export default function ZoneCharts(){
    const [region, setRegion] = useState<Zone>();
    const [distrito, setDistrito] = useState<Zone>();

    useEffect(() => {
        if(region){
            setDistrito(undefined);
        }
    }, [region]);

    return(
        <>
            <Row className="justify-content-center">
                <Col xs={12} md={12 / (region ? 2 : 1)}>
                    <ZoneChart setHook={setRegion} />
                </Col>
                {
                    region &&
                    <Col xs={12} md={6}>
                        <ZoneChart region={region} setHook={setDistrito} />
                    </Col>
                }
            </Row>
            {
                distrito &&
                <Row>
                    <Col xs={12}>
                        <ZoneChart district={distrito} />
                    </Col>
                </Row>
            }
        </>
    )
}